import type { AppRouteRecordRaw } from '@/router/types'

export const clueRecycleManageRoutes: AppRouteRecordRaw[] = [
  {
    path: 'clueRecycleManage',
    name: 'ClueRecycleManage',
    component: () => import('@/views/clueRecycleManage/index.vue'),
    meta: { title: '线索回收站', keepAlive: true }
  },
  {
    path: 'clueRecycleDetail',
    name: 'ClueRecycleDetail',
    component: () => import('@/views/clueRecycleManage/clueRecycleDetail/index.vue'),
    meta: { title: '线索回收站详情' }
  }
]
